import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import StartingPoint from 'components/StartingPoint/StartingPoint.jsx'
import Slot from './components/Slot/Slot.jsx'
import Building from './components/Building/Building.jsx'

import styles from './Direction.scss'

const Direction = (props) => {

    const {
        buildingClickHandler,
        buildingHoverHandler,
        buildingConstructionAnimated,
        emptySlotClickHandler,
        emptySlotHoverHandler,
        hasPermission,
        isOwn,
    } = props

    const children = props.slots.map(slot => {
        const { building } = slot
        if (building !== null) {
            const clickHandler = (buildingClickHandler ? buildingClickHandler.bind(null, building.id) : null)
            const hoverHandler = (buildingHoverHandler ? buildingHoverHandler.bind(null, building.id) : null)
            const constructionAnimatedHandler = (
                buildingConstructionAnimated ? buildingConstructionAnimated.bind(null, building.id) : null
            )
            return (
                <Building
                    key={building.id}
                    building={building}
                    handleClick={clickHandler}
                    handleHover={hoverHandler}
                    buildingConstructionAnimated={constructionAnimatedHandler}
                    isOwn={isOwn}
                />
            )
        } else {
            const clickHandler = (emptySlotClickHandler ? emptySlotClickHandler.bind(null, slot.id) : null)
            const hoverHandler = (emptySlotHoverHandler ? emptySlotHoverHandler.bind(null, slot.id) : null)

            return (
                <Slot
                    key={slot.id}
                    slotId={slot.id}
                    handleClick={clickHandler}
                    handleHover={hoverHandler}
                    hasPermission={hasPermission}
                    isOwn={isOwn}
                />
            )
        }
    })

    const className = classNames(
        styles.base,
        styles[`base__${props.name}`],
        styles[`base__lvl${props.level}`],
    )

    return (
        <div className={className}>
            <StartingPoint direction={props.name}>
                {children}
            </StartingPoint>
        </div>
    )
}

Direction.propTypes = {
    level: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slots: PropTypes.arrayOf(PropTypes.object).isRequired,
    emptySlotClickHandler: PropTypes.func,
    buildingClickHandler: PropTypes.func,
    emptySlotHoverHandler: PropTypes.func,
    buildingHoverHandler: PropTypes.func,
    hasPermission: PropTypes.bool.isRequired,
    isOwn: PropTypes.bool.isRequired,
    buildingConstructionAnimated: PropTypes.func,
}

export default Direction



// WEBPACK FOOTER //
// ./containers/Stronghold/components/Direction/Direction.jsx